export default __webpack_public_path__ + "static/shop-best-sellers-mobile-a042077b702934b29d20375b5f5b933e.webp";